module.exports = __webpack_public_path__ + "static/media/reapply-avatar.6ccba77c.svg";